import { useMemo, useState } from "react";
import Button from "../components/Button";
import Icon from "../components/icons/Icon";
import Podium from "../components/Podium";
import SpielKopf from "../components/SpielKopf";
import SpielMenue from "../components/SpielMenue";
import { farbNummern } from "../spieler";
import "./FinishedScreen.css";

/** Endstand beim Host: Krone, Podest, neue Runde. children: Verlaufs-Dialog. */
export default function FinishedScreen({ players, matchHistory, onLogout, onShowHistory, onNeueRunde, children }) {
  const [menue, setMenue] = useState(false);
  const name = (p, i) => p.name || `Spieler ${i + 1}`;
  const farbe = useMemo(() => farbNummern(players.map(name)), [players]);
  const runden = new Set(matchHistory.map((e) => e.roundNumber)).size;

  return (
    <div className="spiel stimmung-gruen">
      <SpielKopf
        label="Spiel beendet"
        wert={runden === 1 ? "1 Runde" : `${runden} Runden`}
        onMenue={() => setMenue(true)}
      />
      <main className="spiel-mitte">
        <Podium eintraege={players.map((p, i) => ({ key: i, name: name(p, i), score: p.score }))} farbe={farbe} />
      </main>
      <div className="daumenzone">
        <Button variant="haupt" onClick={onNeueRunde}>
          <Icon name="nochmal" />
          Neue Runde
        </Button>
        <Button variant="neben" onClick={onShowHistory}>
          <Icon name="verlauf" />
          Verlauf ansehen
        </Button>
      </div>
      {menue && (
        <SpielMenue
          onClose={() => setMenue(false)}
          eintraege={[
            {
              icon: "tuer",
              label: "Abmelden",
              gefahr: true,
              frage: "Du meldest dich von Spotify ab. Punkte und Verlauf werden gelöscht.",
              bestaetigen: "Abmelden",
              onClick: onLogout,
            },
          ]}
        />
      )}
      {children}
    </div>
  );
}
